module.exports = __webpack_public_path__ + "img/classRoomBannerImg.cb24d052.png";